import Vue from 'vue';
// 通用版权请求code
export const fileTypeList = ($vm) => {
    return [
        {
            label: '商业秘密',
            value: 109,
            selectValue: "BUSINESS_SECURITY",
        },
        {
            label: '工业项目',
            value: 119,
            selectValue: "INDUSTRIAL_PROJECT",
        },
        {
            label: '软件项目',
            value: 108,
            selectValue: "SOFTWARE",
        },
        {
            label: '硬件项目',
            value: 120,
            selectValue: "HARD_PROJECT",
        },
        {
            label: '科研成果',
            value: 121,
            selectValue: "SCIENTIFIC_PAYOFFS",
        },
        {
            label: '数据资产',
            value: 122,
            selectValue: "DATA_ASSETS",
        },
        {
            label: '商标设计',
            value: 123,
            selectValue: "TRADEMARK_DESIGN",
        },
        {
            label: '专利文档',
            value: 124,
            selectValue: "PATENT_DOCUMENT",
        },
        {
            label: '文字作品',
            value: 101,
            selectValue: "WORD",
        },
        {
            label: '视听作品',
            value: 112,
            selectValue: "VIDEO",
        },
        {
            label: '摄影作品',
            value: 110,
            selectValue: "PHOTOGRAPHY",
        },
        {
            label: '美术作品',
            value: 104,
            selectValue: "FINE_ARTS",
        },
        {
            label: '音乐作品',
            value: 102,
            selectValue: "MUSIC",
        },
        {
            label: '设计作品',
            value: 105,
            selectValue: "DESIGN",
        },
        {
            label: '讲义课件',
            value: 125,
            selectValue: "HANDOUTS_COURSEWARE",
        },
        {
            label: '口述作品',
            value: 132,
            selectValue: 'SPEECH_WORK'
        },
        {
            label: '戏剧曲艺作品',
            value: 133,
            selectValue: 'THEATRE_WORK'
        },
        {
            label: '舞蹈杂技作品',
            value: 134,
            selectValue: 'DANCE_WORK'
        },
        {
            label: '建筑作品',
            value: 135,
            selectValue: 'BUILDING_WORK'
        },
        {
            label: '图形作品',
            value: 136,
            selectValue: 'GRAPHIC_WORK'
        },
        {
            label: '模型作品',
            value: 137,
            selectValue: 'MODEL_WORK'
        },
        {
            label: 'AIGC',
            value: 131,
            selectValue: "AIGC",
        },
        {
            label: '其它',
            value: 999,
            selectValue: "OTHER",
        },
    ]
}

export const storeTypeList = ($vm) => {
    return [
        {
            label: '保密认证',
            value: 0,
            selectValue: "DESENSITIZE_STORE",
        },
        {
            label: '存证认证',
            value: 1,
            selectValue: "SAVE_STORE",
        },
    ]
}